import bannerImage from '../images/img_banner.jpg';
import bannerImageDesktop from '../images/img_banner_desktop_rf.jpg';
import symptomChecker from '../images/symptomChecker.svg'
// import vaccination from '../images/Vaccination.svg'
import healthPatri from '../images/healthPatri.svg'
import consultDoctorOnline from '../images/consultDoctorOnline.svg'
import findDoctorNearMe from '../images/findDoctorNearMe.svg'
import ABDMLogo from '../images/nhalogo.png'
import selfChecker from "../images/selfChecker.svg";
import config, { teams_app_id, teams_app_id_public } from '../config.json';
import healthLocker from "../images/healthLocker.svg";

export default {
  title: 'JioHealth',
  Language: 'English',
  bannerImage,
  bannerImageDesktop,
  // eslint-disable-next-line max-len
  description: 'Your complete health companion',
  available_options: [
    {
      id: 0,
      icon: healthLocker,
      name: "HEALTH_LOCKER_TITLE",
      description: "HEALTH_LOCKER_SUBTITLE",
      navigateTo: config.health_locker_webapp_url,
      // tabId: `${teams_app_id}/02`
    },
    {
      id: 1,
      icon: selfChecker,
      name: "SELF_CHECKER_TITLE",
      description: "SELF_CHECKER_SUBTITLE",
      navigateTo: config.self_checker_webapp_url,
      // tabId: `${teams_app_id}/10`
    },
    {
      id: 2,
      icon: selfChecker,
      name: 'AI_SYMPTOM_CHECKER_TITLE',
      description: 'AI_SYMPTOM_CHECKER_SUBTITLE',
      navigateTo:  `${config.self_checker_webapp_url}?workflow_id=avighna`,
      // tabId: `${teams_app_id}/03`
    },
    // {
    //   id: 3,
    //   icon: vaccination,
    //   name: 'VACCINATION_TITLE',
    //   description: 'VACCINATION_SUBTITLE',
    //   navigateTo: config.jhh_webapp_url,
    //   // tabId: `${teams_app_id}/04`
    // },
    {
      id: 4,
      icon: healthPatri,
      name: 'HEALTHPATRI_TITLE',
      description: 'HEALTHPATRI_SUBTITLE',
      navigateTo: config.healthpatri_webapp_url,
      // tabId: `${teams_app_id}/05`
    },
    {
      id: 5,
      icon: consultDoctorOnline,
      name: "CONSULTATION_TITLE",
      description: "CONSULTATION_SUBTITLE",
      navigateTo: config.consultation_search_webapp_url,
      // tabId: `${teams_app_id}/08`
    },
    {
      id: 6,
      icon: findDoctorNearMe,
      name: "CONSULTATION_NEAR_ME_TITLE",
      description: "CONSULTATION_NEAR_ME_SUBTITLE",
      navigateTo: config.consultation_near_me_webapp_url,
      // tabId: `${teams_app_id}/08`
    },
    {
      id: 7,
      icon: ABDMLogo,
      name: "NATIONAL_HEALTH_ID",
      description: "NATIONAL_HEALTH_ID_DESCRIPTION",
      navigateTo: config.national_health_id_webapp_url,
      // tabId: `${teams_app_id}/06`
    }
  ],
  ril_available_options: [
    {
      id: 0,
      icon: healthLocker,
      name: "HEALTH_LOCKER_TITLE",
      description: "HEALTH_LOCKER_SUBTITLE",
      navigateTo: config.health_locker_webapp_url,
      tabId: `${teams_app_id}/02`
    },
    // {
    //   id: 1,
    //   icon: selfChecker,
    //   name: "SELF_CHECKER_TITLE",
    //   description: "SELF_CHECKER_SUBTITLE",
    //   navigateTo: config.self_checker_webapp_url,
    //   // tabId: `${teams_app_id}/10`
    // },
    {
      id: 2,
      icon: symptomChecker,
      name: 'SYMPTOM_CHECKER_TITLE',
      description: 'SYMPTOM_CHECKER_SUBTITLE',
      navigateTo: '/workflow',
      tabId: `${teams_app_id}/03`
    },
    // {
    //   id: 3,
    //   icon: vaccination,
    //   name: 'VACCINATION_TITLE',
    //   description: 'VACCINATION_SUBTITLE',
    //   navigateTo: config.jhh_webapp_url,
    //   tabId: `${teams_app_id}/04`
    // },
    {
      id: 4,
      icon: healthPatri,
      name: 'HEALTHPATRI_TITLE',
      description: 'HEALTHPATRI_SUBTITLE',
      navigateTo: config.healthpatri_webapp_url,
      tabId: `${teams_app_id}/05`
    },
    {
      id: 5,
      icon: consultDoctorOnline,
      name: "CONSULTATION_TITLE",
      description: "CONSULTATION_SUBTITLE",
      navigateTo: config.consultation_search_webapp_url,
      tabId: `${teams_app_id}/06`
    },
    {
      id: 6,
      icon: findDoctorNearMe,
      name: "CONSULTATION_NEAR_ME_TITLE",
      description: "CONSULTATION_NEAR_ME_SUBTITLE",
      navigateTo: config.consultation_near_me_webapp_url,
      tabId: `${teams_app_id}/07`
    },
    {
      id: 7,
      icon: ABDMLogo,
      name: "NATIONAL_HEALTH_ID",
      description: "NATIONAL_HEALTH_ID_DESCRIPTION",
      navigateTo: config.national_health_id_webapp_url,
      tabId: `${teams_app_id}/08`
    }
  ],
  public_available_options: [
    {
      id: 0,
      icon: healthLocker,
      name: "HEALTH_LOCKER_TITLE",
      description: "HEALTH_LOCKER_SUBTITLE",
      navigateTo: config.health_locker_webapp_url,
      tabId: `${teams_app_id_public}/02`
    },
    {
      id: 1,
      icon: symptomChecker,
      name: 'SYMPTOM_CHECKER_TITLE',
      description: 'SYMPTOM_CHECKER_SUBTITLE',
      navigateTo: '/workflow',
      tabId: `${teams_app_id_public}/03`
    },
    // {
    //   id: 2,
    //   icon: vaccination,
    //   name: 'VACCINATION_TITLE',
    //   description: 'VACCINATION_SUBTITLE',
    //   navigateTo: config.jhh_webapp_url,
    //   tabId: `${teams_app_id_public}/04`
    // },
    {
      id: 3,
      icon: healthPatri,
      name: 'HEALTHPATRI_TITLE',
      description: 'HEALTHPATRI_SUBTITLE',
      navigateTo: config.healthpatri_webapp_url,
      tabId: `${teams_app_id_public}/05`
    },
    {
      id: 4,
      icon: ABDMLogo,
      name: "NATIONAL_HEALTH_ID",
      description: "NATIONAL_HEALTH_ID_DESCRIPTION",
      navigateTo: config.national_health_id_webapp_url,
      tabId: `${teams_app_id_public}/06`
    }
  ]
};
